import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaRegEyeSlash,
  FaRegEye,
  FaUser,
  FaLock,
  FaEnvelope,
} from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import logo from "../../assets/logo.png";
import meo from "../../assets/image/meo.jpg";
import axios from "axios";
import BASE_URL from "../../configs/api";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";

const Register = ({ isOpen, onClose, onSwitchToLogin }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    last_name: "",
    first_name: "",
    email: "",
    password: "",
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  if (!isOpen) return null;

  const handleInputChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleCaptchaChange = (value) => {
    setRecaptchaValue(value);
    if (error?.includes("reCAPTCHA")) setError(null);
  };

  const resetForm = () => {
    setFormData({
      username: "",
      last_name: "",
      first_name: "",
      email: "",
      password: "",
    });
    setRecaptchaValue(null);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!recaptchaValue) {
      setError("Vui lòng xác minh reCAPTCHA.");
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      await axios.post(`${BASE_URL}/api/auth/register/`, {
        ...formData,
        recaptcha_token: recaptchaValue,
      });

      toast.success("Đăng ký thành công! Bạn có thể đăng nhập ngay bây giờ.");
      resetForm();
      onClose();
      onSwitchToLogin();
    } catch (err) {
      const errors = err.response?.data;
      let errorMsg = "Đăng ký thất bại. Vui lòng thử lại.";

      if (errors) {
        if (errors.username) errorMsg = `Tên đăng nhập: ${errors.username[0]}`;
        else if (errors.email) errorMsg = `Email: ${errors.email[0]}`;
        else if (errors.password) errorMsg = `Mật khẩu: ${errors.password[0]}`;
        else if (typeof errors === "string") errorMsg = errors;
        else errorMsg = errors.detail || errors.message || errorMsg;
      }

      toast.error(errorMsg);
      setError(errorMsg);
    } finally {
      setIsLoading(false);
    }
  };

  // --- THAY ĐỔI: Giảm padding dọc (py-3 -> py-2.5) cho input nhỏ gọn hơn ---
  const inputClass =
    "block w-full bg-[#2a314e] border border-white/20 rounded-lg py-2.5 text-white placeholder-gray-400 focus:ring-2 focus:ring-yellow-500 focus:border-transparent outline-none transition-all duration-200 hover:border-white/30";

  return (
    <div
      className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[999] p-4"
      onClick={onClose}
    >
      {/* --- THAY ĐỔI: Giảm max-w-5xl thành max-w-4xl --- */}
      <div
        className="bg-[#191B28] w-full max-w-4xl rounded-2xl shadow-2xl flex overflow-hidden relative animate-in fade-in duration-300 max-h-[95vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 z-20 text-gray-400 hover:text-white transition-colors duration-200 bg-black/20 hover:bg-black/40 rounded-full p-2"
          aria-label="Đóng"
        >
          <IoClose size={20} />
        </button>

        {/* --- THAY ĐỔI: Điều chỉnh tỷ lệ panel ảnh (w-2/5 -> w-1/3) --- */}
        <div className="hidden lg:block lg:w-[40%] relative bg-gradient-to-br from-gray-800 to-gray-900">
          <img
            src={meo}
            alt="Register"
            className="absolute inset-0 w-full h-full object-cover opacity-40"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1e2545] via-transparent to-transparent"></div>
          {/* --- THAY ĐỔI: Giảm padding và kích thước text/logo --- */}
          <div className="relative z-10 flex flex-col items-start justify-end h-full p-8">
            <img src={logo} alt="Logo" className="w-[150px] h-auto mb-3" />
            <h3 className="text-white text-lg font-semibold mb-2">
              Chào mừng bạn mới!
            </h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              Tạo tài khoản để khám phá thế giới phim tuyệt vời.
            </p>
          </div>
        </div>

        {/* --- THAY ĐỔI: Điều chỉnh tỷ lệ panel form (w-3/5 -> w-2/3) và padding --- */}
        <div className="w-full lg:w-[60%] p-2 overflow-y-auto">
          <div className="lg:hidden flex justify-center mb-6">
            <img src={logo} alt="Logo" className="w-[120px] h-auto" />
          </div>

          <div className="max-w-md mx-auto w-full">
            {/* --- THAY ĐỔI: Đồng bộ kích thước font và margin --- */}
            <h2 className="text-2xl font-bold text-white mb-1 text-center lg:text-left">
              Đăng ký tài khoản
            </h2>
            <p className="text-sm text-neutral-400 mb-6 text-center lg:text-left">
              Bạn đã có tài khoản?{" "}
              <button
                onClick={onSwitchToLogin}
                className="text-yellow-500 hover:text-yellow-400 transition-colors duration-200 font-medium hover:underline"
              >
                Đăng nhập ngay
              </button>
            </p>

            {error && (
              <div className="mb-4 p-3 bg-red-900/30 border border-red-600/50 rounded-lg">
                <p className="text-red-400 text-sm font-medium">{error}</p>
              </div>
            )}

            {/* --- THAY ĐỔI: Giữ space-y-4 để có khoảng cách vừa phải --- */}
            <form onSubmit={handleRegister} className="space-y-4">
              {/* Username */}
              <div>
                {/* --- THAY ĐỔI: Thêm mb-2 cho label để nhất quán --- */}
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Tên đăng nhập
                </label>
                <div className="relative">
                  <FaUser
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                    size={16}
                  />
                  <input
                    type="text"
                    required
                    value={formData.username}
                    onChange={handleInputChange("username")}
                    placeholder="Nhập tên đăng nhập"
                    className={`${inputClass} pl-12 pr-4`}
                    disabled={isLoading}
                  />
                </div>
              </div>

              {/* Name Fields */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Họ
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.last_name}
                    onChange={handleInputChange("last_name")}
                    placeholder="Nhập họ"
                    className={`${inputClass} px-4`}
                    disabled={isLoading}
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-300 mb-2">
                    Tên
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.first_name}
                    onChange={handleInputChange("first_name")}
                    placeholder="Nhập tên"
                    className={`${inputClass} px-4`}
                    disabled={isLoading}
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Email
                </label>
                <div className="relative">
                  <FaEnvelope
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                    size={16}
                  />
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange("email")}
                    placeholder="Nhập địa chỉ email"
                    className={`${inputClass} pl-12 pr-4`}
                    disabled={isLoading}
                  />
                </div>
              </div>

              {/* Password */}
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">
                  Mật khẩu
                </label>
                <div className="relative">
                  <FaLock
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
                    size={16}
                  />
                  <input
                    type={showPassword ? "text" : "password"}
                    required
                    value={formData.password}
                    onChange={handleInputChange("password")}
                    placeholder="Nhập mật khẩu"
                    className={`${inputClass} pl-12 pr-12`}
                    disabled={isLoading}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 text-neutral-400 hover:text-white transition-colors duration-200"
                    disabled={isLoading}
                  >
                    {showPassword ? (
                      <FaRegEyeSlash size={18} />
                    ) : (
                      <FaRegEye size={18} />
                    )}
                  </button>
                </div>
              </div>

              {/* reCAPTCHA */}
              <div className="flex justify-center py-2">
                <div className="transform scale-90 origin-center">
                  <ReCAPTCHA
                    sitekey="6LdYZjcrAAAAAMRDdY0l10bwstM8v_yCazpJF2RA"
                    onChange={handleCaptchaChange}
                    theme="dark"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={isLoading || !recaptchaValue}
                className="w-full text-black font-semibold py-3 rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed hover:shadow-lg transform hover:scale-[1.02] active:scale-[0.98]"
                style={{
                  background:
                    isLoading || !recaptchaValue
                      ? "linear-gradient(39deg, rgba(200, 200, 200, 1), rgba(220, 220, 220, 1))"
                      : "linear-gradient(39deg, rgba(254, 207, 89, 1), rgba(255, 241, 204, 1))",
                }}
              >
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-black mr-2"></div>
                    Đang tạo tài khoản...
                  </div>
                ) : (
                  "Tạo tài khoản"
                )}
              </button>
            </form>

            {!recaptchaValue && !isLoading && (
              <p className="text-xs text-amber-400 text-center mt-4 animate-pulse">
                Vui lòng hoàn thành xác minh reCAPTCHA để tiếp tục
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
